import { createWorkflowActions } from '@tock/shared/workflow/actionCreators';
import AppConstants from 'constants/AppConstants';

export function exportMarketingOptInCsv(): ApiAction {
  return {
    TockApi: {
      postProto: '/export/marketing-opt-in-csv',
      type: AppConstants.EXPORT_MARKETING_OPT_IN_CSV,
    },
  };
}

export function dismissExport(id: string): BaseTockAction {
  return {
    type: AppConstants.EXPORT_DISMISS,
    payload: id,
  };
}

export const {
  fetchWorkflowStatus: fetchMarketingOptInWorkflowStatus,
  fetchWorkflowResult: fetchMarketingOptInWorkflowResult,
} = createWorkflowActions({
  statusType: AppConstants.EXPORT_MARKETING_OPT_IN_CSV_WORKFLOW_STATUS,
  resultType: AppConstants.EXPORT_MARKETING_OPT_IN_CSV_WORKFLOW_RESULTS,
  errorType: AppConstants.EXPORT_MARKETING_OPT_IN_CSV_WORKFLOW_FAILED,
});
